module.exports = __webpack_public_path__ + "static/img/200334.0719b7b3.png";